// 以1920px设计稿为基准，动态计算根字体大小
// postcss-pxtorem 会将所有 px 转为 rem (rootValue: 100)
// 移动端设置最小根字体，保证文字可读性
const DESIGN_WIDTH = 1920;
const BASE_FONT = 100;
const MIN_ROOT_FONT = 48; // 移动端最小根字体，确保14px文字至少~7px

export function setRemUnit() {
  const clientWidth = document.documentElement.clientWidth;
  const rem = clientWidth * (BASE_FONT / DESIGN_WIDTH);
  document.documentElement.style.fontSize = `${Math.max(rem, MIN_ROOT_FONT)}px`;
}

// 防抖处理
let timer;
export function handleResize() {
  clearTimeout(timer);
  timer = setTimeout(setRemUnit, 300);
}



// WEBPACK FOOTER //
// ./src/utils/flexible.js